export const sendEvent = (eventInfo) => {
    if (!eventInfo) return
    const GAEvent = eventInfo.split(':')
    gtag('event', 'click', {
        'event_category': GAEvent[0],
        'event_action': GAEvent[1] ? GAEvent[1] : 'click',
        'event_label': GAEvent[2] ? GAEvent[2] : GAEvent[1],
    })
}



// WEBPACK FOOTER //
// ./src/methods/ga.js